"use client";

import ChartLineMyEstate from "@/components/portfolio/ChartLineMyEstate";
import EstateCardList from "@/components/portfolio/EstateCardList";
import { PortfolioRenovationPotential } from "@/components/portfolio/portfolio-page/PortfolioRenovationPotential";
import { Records } from "@/components/portfolio/Records";
import { TransactionHintWindow } from "@/components/portfolio/TransactionHintWindow";

type PortfolioSelectedEstateSectionProps = {
  hasSelectedEstate: boolean;
  isGraphView: boolean;
  isHintOpen: boolean;
  onToggleHint: () => void;
};

export function PortfolioSelectedEstateSection({
  hasSelectedEstate,
  isGraphView,
  isHintOpen,
  onToggleHint,
}: PortfolioSelectedEstateSectionProps) {
  if (!hasSelectedEstate) return null;

  return (
    <div className="space-y-4">
      <TransactionHintWindow isOpen={isHintOpen} onToggle={onToggleHint} />
      {isGraphView ? <ChartLineMyEstate /> : <EstateCardList />}
      <PortfolioRenovationPotential />
      <Records />
    </div>
  );
}
